/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Ivan Ryabov
 */
import React, { Component } from 'react'
import moment from 'moment'

import './TimePicker.css'

export default class TimePicker extends Component {

    constructor(props) {
        super(props)
        
        let hours = '12'
        let minutes = '00'
        let ampm = 'AM'

        if (this.props.value) {
            const mtime = moment(this.props.value, 'HH:mm:ss')
            hours = mtime.format('h')
            minutes = mtime.format('mm')
            ampm = mtime.format('A')
        }

        this.state = {
            hours,
            minutes,
            ampm,
            open: false,
            isTop: false,
            timeString: this.getTimeString({hours, minutes, ampm})
        }

        this.hours = Array(12).fill(0).map((v,i) => (i + 1).toString())
        this.minutes = ['00', '15', '30', '45']
        this.ampm = ['AM', 'PM']

        this.close = this.close.bind(this)
        this.open = this.open.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.value !== nextProps.value) {
            const mtime = moment(nextProps.value, 'HH:mm:ss')
            const hours = mtime.format('h')
            const minutes = mtime.format('mm')
            const ampm = mtime.format('A')
            const state = {
                hours,
                minutes,
                ampm
            }

            state.timeString = this.getTimeString(state)
            this.setState(state)
        }
    }

    render() {
        const hours = this.hours.map((h, ix) => {
            const activeClass = h === this.state.hours ? 'active' : ''
            return (<div key={ix} className={`item ${activeClass}`} onClick={ () => { this.chooseHours(h) } }>{h}</div>)
        })

        const minutes = this.minutes.map((m, ix) => {
            const activeClass = m === this.state.minutes ? 'active' : ''
            return (<div key={ix} className={`item ${activeClass}`} onClick={ () => {this.chooseMinutes(m)} }>{m}</div>)
        })

        const ampm = this.ampm.map((ap, ix) => {
            const activeClass = ap === this.state.ampm ? 'active' : ''
            return (<div key={ix} className={`item ${activeClass}`} onClick={ () => {this.chooseAMPM(ap)} }>{ap}</div>)
        })

        const openedClass = this.state.open ? 'opened' : 'closed'
        const isTopClass = this.state.isTop ? 'top' : ''

        return (
            <div className="TimePicker TRCInput"
                ref={(el) => { this.rootEl = el }} >
                <input className="trace-input" value={this.state.timeString} onFocus={this.open} type="text" />
                <div className={`wrapper ${openedClass} ${isTopClass}`}>
                    <div className="column hours">{hours}</div>
                    <div className="column minutes">{minutes}</div>
                    <div className="column ampm">{ampm}</div>
                </div>
                <div className={`backdrop ${openedClass}`} onClick={this.close}></div>
            </div>
        )
    }

    close() {
        this.setState({
            open: false
        })
    }

    open() {
        let isTop = false
        if (this.rootEl) {
            const elRect = this.rootEl.getBoundingClientRect()
            if (elRect.y + 350 > window.innerHeight) {
                isTop = true
            }
        }
        this.setState({
            open: true,
            isTop
        })
    }

    chooseHours(val) {
        let state = {...this.state}
        state.hours = val
        let timeString = this.getTimeString(state)
        this.onChange(timeString)
        this.setState({
            hours: val,
            timeString
        })
    }

    chooseMinutes(val) {
        let state = {...this.state}
        state.minutes = val
        let timeString = this.getTimeString(state)
        this.onChange(timeString)
        this.setState({
            minutes: val,
            timeString
        })
    }

    chooseAMPM(val) {
        let state = {...this.state}
        state.ampm = val
        let timeString = this.getTimeString(state)
        this.onChange(timeString)
        this.setState({
            ampm: val,
            timeString
        })
    }

    getTimeString(state) {
        return `${state.hours}:${state.minutes} ${state.ampm}`
    }

    onChange(timeString) {
        if (this.props.onChange) {
            const mtime = moment(timeString, 'h:mm A')
            this.props.onChange({currentTarget: {value: mtime.format('HH:mm:ss')}})
        }
    }
}
